import React, { useState } from 'react'
import styled from 'styled-components'

import { confirmPassword, required } from 'utils/validations'

import { getEulaUrl } from 'containers/EULAModal/constants'

import MultiStepForm from 'components/elements/MultiStepForm/MultiStepForm'
import OldModal from 'components/lib/OldModal'

import FirstPasswordForm from '../FirstPasswordForm'
import FirstSettingsForm from '../FirstSettingsForm'

const FormHeader = styled(({ className }) => (
  <div className={className}>
    <h2>Welcome to IRONSCALES!</h2>
    <h3>Please set the following settings to get started</h3>
  </div>
))`
  display: flex;
  flex-direction: column;
  gap: 32px;
  * {
    color: ${({ theme }) => theme.colors.text.primary};
    margin: 0;
  }
  h2 {
    font-weight: ${({ theme }) => theme.typography.weight.semibold};
    font-size: ${({ theme }) => theme.typography.size.main};
  }
  h3 {
    font-size: ${({ theme }) => theme.typography.size.body};
    font-weight: ${({ theme }) => theme.typography.weight.regular};
  }
`

export default function FirstLoginModal({
  submitFirstLogin,
  loader,
  error,
  success,
  isFirstLogin,
  eulaType,
  defaultWorkDays,
  defaultTimezone,
  defaultCountry,
}) {
  const [values, setValues] = useState({
    password: '',
    newPassword: '',
    repeatNewPassword: '',
    enforcePasswords: false,
    twoFactorAuth: false,
    timezone: defaultTimezone,
    country: defaultCountry,
    eula: false,
    workDays: defaultWorkDays,
    eulaType,
    eulaVersion: getEulaUrl(eulaType),
  })

  const passwordValidator = {
    password: required,
    newPassword: required,
    repeatNewPassword: confirmPassword(values.newPassword, values.repeatNewPassword),
  }

  const settingsValidator = {
    eula: () => (values.eula ? undefined : 'You must sign on the user agreement'),
    country: required,
    timezone: required,
    workDays: required,
  }

  const passwordValidate = (key, value) => passwordValidator[key](value)

  const settingsValidate = (key, value) => settingsValidator[key](value)

  const validatePassowrds = {
    password: passwordValidate('password', values.password),
    newPassword: passwordValidate('newPassword', values.newPassword),
    repeatNewPassword: passwordValidate('repeatNewPassword'),
  }

  const validateSettings = {
    eula: settingsValidate('eula'),
  }

  const changeField = (key, value) => {
    setValues((prevValues) => ({
      ...prevValues,
      [key]: value,
    }))
  }
  if (!isFirstLogin) return null

  return (
    <OldModal id="modal" width="480px">
      <MultiStepForm
        loader={loader}
        success={success}
        steps={[
          <FirstSettingsForm
            validator={validateSettings}
            onChange={changeField}
            timezone={values.timezone}
            buisnessDays={values.buisnessDays}
            eula={values.eula}
            country={values.country}
            eulaType={eulaType}
            workDays={values.workDays}
          />,
          <FirstPasswordForm
            error={error}
            validator={validatePassowrds}
            onChange={changeField}
            password={values.password}
            newPassword={values.newPassword}
            repeatNewPassword={values.repeatNewPassword}
            enforcePasswords={values.enforcePasswords}
            twoFactorAuth={values.twoFactorAuth}
          />,
        ]}
        values={values}
        validationSchemes={[validateSettings, validatePassowrds]}
        header={<FormHeader />}
        onSubmit={() => submitFirstLogin(values)}
        id="First_Login_Multi_Step_Form"
        validators={[settingsValidate, passwordValidate]}
      />
    </OldModal>
  )
}
